import Index from "./index.vue"

export default [{ path: "security", name: "settings-security", component: Index, title: "Security" }]
